import {connect} from 'react-redux';

import {getShouldHideTeamTagCounters} from '../../../../../libs/shared/core/src/store/featureFlags/featureFlagsSelectors';
import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {DelegationModel} from '../../../../models/api/delegationModel';
import {AppState} from '../../../../store/appState';
import {makeGetDelegationVisualCustomViews} from '../../../../store/data/preferences/customViewsSelectors';
import {nestSingleTagInsideNewParentAction} from '../../../../store/data/tags/saveTagActions';
import {reorderTagInPersonalWorkspaceAsyncAction} from '../../../../store/data/workspace/workspaceActions';
import {WorkspaceCustomViews} from '../workspaceCustomViews';

/*
 * Props.
 */

interface DelegationWorkspaceCustomViewsContainerProps {
  delegation: DelegationModel;
}

/*
 * Selectors.
 */

function getDelegation(_state: AppState, props: DelegationWorkspaceCustomViewsContainerProps) {
  return props.delegation;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<DelegationWorkspaceCustomViewsContainerProps>()(() => ({
  visualCustomViews: makeGetDelegationVisualCustomViews(getDelegation),
  shouldHideTeamTagCounters: getShouldHideTeamTagCounters,
}));

export const DelegationWorkspaceCustomViewsContainer = connect(mapStateToProps, {
  onDropReorderCustomView: reorderTagInPersonalWorkspaceAsyncAction,
  onDropNestCustomView: nestSingleTagInsideNewParentAction,
})(WorkspaceCustomViews);
